
export interface ProductCategory {
    id: number;
    name: string;
}

export class Product {
    id: string;
    name: string;
    active: boolean;
    productCategoryId: number;
    productCategory: ProductCategory;
    workflowId: string;
    description: string;
    tenantName: string;
    metadata: string;
}

export enum ProductAvailability {
    Active = 'Active',
    WithCase = 'WithCase',
    NoCase = 'NoCase',
    Disabled = 'Disabled',
    NotAvailable = 'NotAvailable',
    NoMatchingStage = 'NoMatchingStage'
}

export interface ActionConfig {
    displayName?: string;
    description?: string;
    disabled?: boolean;
}

export interface StageTrackerConfig {
    displayName?: string;
    description?: string;
    action?: ActionConfig;
}


